var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"service acea-row row-middle row-center"},[_c('img',{staticClass:"img",attrs:{"src":_vm.imgUrl,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }